import(/* webpackMode: "eager" */ "/vercel/path0/app/connection-test/page.tsx");
